import { initI18n, initLanguage } from './commons';
import { TR, TROrNA, TRHtml } from './TR';

export { initI18n, initLanguage, TR, TROrNA, TRHtml };
